import * as React from 'react';
import Map from './Map';
import SearchAppBar from './SearchAppBar';
//import * as THREEINIT from './threeinit6'; // for star application
import * as THREEINIT from './threeinit_10pc'; // for brightest 60 10 pc stars visualization
//import * as THREEINIT from './threeinit7'; // for small star application
//import * as THREEINIT from './threeinit5'; // for proper motion application

import {default as FormControlLabel} from '@material-ui/core/FormControlLabel';
import {default as Accordion} from '@material-ui/core/Accordion';
import {default as AccordionSummary} from '@material-ui/core/AccordionSummary';
import {default as AccordionDetails} from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import Fade from '@material-ui/core/Fade';
import {default as Typography } from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './App.css';

class AppContent extends React.Component<any,any> {
  constructor(props:any) {
    super(props);
    this.setScriptText = this.setScriptText.bind(this);
  }
  state = {
    scriptText: [],
    scriptTextVisible: false,
    scriptBottomText: [],
    scriptBottomTextVisible: false
  }

  public componentDidMount() {
    //this.props.setSearchDone(true);
    THREEINIT.init(this.setScriptText);
    THREEINIT.animate(); 
  }

  public setScriptText(s:string,v:boolean,p:string) {
    console.log('in setScriptText',v,s,p);
    const t = s.split('\\n');
    console.log(t);
    if (p == 'center') {
      this.setState({scriptText: t ,scriptTextVisible: v});
    } else if (p == 'bottom') {
      this.setState({scriptBottomText: t ,scriptBottomTextVisible: v});
    }
  }

  public getFilterOptions(defaultOptions: any): any {
    const options = ((document.getElementById('gaia-filter')!) as HTMLInputElement).value;
    if (options) {
      const option_bits = options.split('|');
      const updatedArray = defaultOptions.map((g:any) => {
        g.children = g.children.map((item:any) => {
          item.checked = option_bits.includes(item.itemCode);
          return item;
        });
        return g;
      });
      return updatedArray;
    } else {
      return defaultOptions;
    }
  }

  public getFilterOptionsMesh(defaultOptions: any): any {
    const options = ((document.getElementById('gaia-filterMesh')!) as HTMLInputElement).value;
    if (options) {
      const option_bits = options.split('|');
      const updatedArray = defaultOptions.map((item:any) => {
          item.checked = option_bits.includes(item.itemCode);
          return item;
        });
      return updatedArray;
    } else {
      return defaultOptions;
    }
  }

  public getFilterOptionsPM(defaultOptions: any): any {
    const options = ((document.getElementById('gaia-filterPM')!) as HTMLInputElement).value;
    if (options) {
      const option_bits = options.split('|');
      const updatedArray = defaultOptions.map((g:any) => {
        g.children = g.children.map((item:any) => {
          item.checked = option_bits.includes(item.itemCode);
          return item;
        });
        return g;
      });
      return updatedArray;
    } else {
      return defaultOptions;
    }
  }

  public render() {
    let checked = true;
    //console.log('props in AppContent',this.props);
    // const filterOptionsDefault = [
    //   {name:'Stars by type', children: [
    //     { itemCode: 'O', itemLabel: 'Intrinsically hot OBA stars', checked: true },
    //     { itemCode: 'G', itemLabel: 'Solar like stars', checked: true },
    //     { itemCode: 'L', itemLabel: 'K-class stars', checked: true },
    //     { itemCode: 'W', itemLabel: 'White dwarfs', checked: true },
    //     { itemCode: 'U', itemLabel: 'Ultra cool dwarfs', checked: true },
    //     { itemCode: 'P', itemLabel: 'Stars with known planets', checked: true },
    //     { itemCode: 'ZL', itemLabel: 'Primaries for the 60 most luminous star systems', checked: true },
    //   ]},
    //   {name:'Other', children: [
    //     { itemCode: 'Q', itemLabel: 'GCNS within 5 parsecs', checked: true },
    //     { itemCode: 'J', itemLabel: 'GCNS within 10 parsecs', checked: true },
    //     { itemCode: 'V', itemLabel: 'Stars visible to the eye', checked: true },
    //   ]},
    //   {name:'Non-GCNS stars', children: [
    //     { itemCode: 'ZQ', itemLabel: 'Non-GCNS within 5 parsecs', checked: true },
    //     { itemCode: 'ZJ', itemLabel: 'Non-GCNS within 10 parsecs', checked: true },
    //   ]},
    // ];

    const filterOptionsDefault = [
      {name:'Objects by type', children: [
        { itemCode: 'sA', itemLabel: 'A-class stars', checked: true },
        { itemCode: 'sF', itemLabel: 'F-class stars', checked: true },
        { itemCode: 'sG', itemLabel: 'G-class (Solar-like) stars', checked: true },
        { itemCode: 'sK', itemLabel: 'K-class stars', checked: true },
        { itemCode: 'sM', itemLabel: 'M-class stars', checked: true },
        { itemCode: 'W', itemLabel: 'White dwarfs', checked: true},
        { itemCode: 'U', itemLabel: 'Brown dwarfs', checked: true },
        { itemCode: 'Pl', itemLabel: 'Planets', checked: true },
        { itemCode: 'P', itemLabel: 'Star systems with known planets', checked: true },
        { itemCode: 'M', itemLabel: '60 most luminous star systems', checked: true },
      ]},
      {name:'Other', children: [
        { itemCode: '5', itemLabel: 'Stars within 5 parsecs', checked: true},
        { itemCode: 'Vi', itemLabel: 'Stars visible to the eye', checked: true },
      ]},
    ];

    /* const filterOptionsDefault = [
      {name:'Clusters and moving groups', children: [
        { itemCode: 'C1', itemLabel: 'Hyades', checked: true },
        { itemCode: 'C2', itemLabel: 'Coma', checked: true },
        { itemCode: 'C3', itemLabel: 'Tucana and Horologium association', checked: true },
        { itemCode: 'C4', itemLabel: '32 Ori', checked: true },
        { itemCode: 'C5', itemLabel: 'eta Cha', checked: true },
        { itemCode: 'C6', itemLabel: 'Ursa Major moving group', checked: true },
        { itemCode: 'C7', itemLabel: 'AB Dor moving group', checked: true },
        { itemCode: 'C8', itemLabel: 'beta Pic moving group', checked: true },
        { itemCode: 'C9', itemLabel: 'Carina Near moving group', checked: true },
      ]},
      {name:'Stars by type', children: [
        { itemCode: 'B', itemLabel: 'Wide binary systems', checked: true },
      ]},
      {name:'Other', children: [
        { itemCode: 'V', itemLabel: 'Stars visible to the eye', checked: true },
      ]},
    ];*/

    const filterOptionsDefaultMesh = [
        { itemCode: 'sun', itemLabel: 'Sun', checked: true },
        { itemCode: 'pc5', itemLabel: 'Stars out to 5 pc', checked: false },
        { itemCode: 'pc10', itemLabel: 'Stars out to 10 pc', checked: false }
    ];

    const filterOptionsDefaultPM = [
      {name:'Clusters and moving groups', children: [
        { itemCode: 'C1', itemLabel: 'Hyades', checked: true },
        { itemCode: 'C2', itemLabel: 'Coma', checked: true },
        { itemCode: 'C3', itemLabel: 'Tucana and Horologium association', checked: true },
        { itemCode: 'C4', itemLabel: '32 Ori', checked: true },
        { itemCode: 'C5', itemLabel: 'eta Cha', checked: true },
        { itemCode: 'C6', itemLabel: 'Ursa Major moving group', checked: true },
        { itemCode: 'C7', itemLabel: 'AB Dor moving group', checked: true },
        { itemCode: 'C8', itemLabel: 'beta Pic moving group', checked: true },
        { itemCode: 'C9', itemLabel: 'Carina Near moving group', checked: true },
      ]},
      {name:'Stars by type', children: [
        { itemCode: 'B', itemLabel: 'Wide binary systems', checked: true },
      ]},
      {name:'Stars by origin', children: [
        { itemCode: 'H', itemLabel: 'Halo objects', checked: true },
        { itemCode: 'T', itemLabel: 'Thick disk and halo', checked: true },
      ]},
    ];

    const filterOptions = this.getFilterOptions(filterOptionsDefault);
    const filterOptionsMesh = this.getFilterOptionsPM(filterOptionsDefaultMesh);
    const filterOptionsPM = this.getFilterOptionsPM(filterOptionsDefaultPM);

    const displayText = this.state.scriptText.map((t:string, i:number) => {                     
      return (<span>{t}<br /></span>) 
    });

    const displayBottomText = this.state.scriptBottomText.map((t:string, i:number) => {                     
      return (<span>{t}<br /></span>) 
    });

   const isVisible = this.state.scriptTextVisible?'visible':'hidden';
   const isBottomVisible = this.state.scriptBottomTextVisible?'visible':'hidden';

    return (
      <div className="AppContent">
        <SearchAppBar
          guideBit={this.props.guideBit}
          zoom_bookmarkBit={this.props.zoom_bookmarkBit}
          search={this.props.search}
          setSearch={this.props.setSearch}
          setSearchDone={this.props.setSearchDone}
          setOptions={this.props.setOptions}
          setFilterOptions={this.props.setFilterOptions}
          setFilterOptionsMesh={this.props.setFilterOptionsMesh}
          setFilterOptionsPM={this.props.setFilterOptionsPM}
          setError={this.props.setError}
          errorMsg={this.props.errorMsg}
          windowHeight={this.props.windowHeight}
          windowWidth={this.props.windowWidth}
          filterOptions={filterOptions}
          filterOptionsMesh={filterOptionsMesh}
          filterOptionsPM={filterOptionsPM}
        />
        <div style={{display: 'flex', visibility:isVisible, justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', border: 'none',position:'absolute',zIndex:10}}>
          <div id="text-overlay" contentEditable style={{overflow: 'auto', padding:30, width:300, backgroundColor: '#333333', color:'white', textAlign: 'left',fontSize:'1.2em', border: 'ridge 1px'}}>
            {displayText}
          </div>
        </div>
        <div style={{display: 'flex', visibility:isBottomVisible, flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center', height: '100%', width: '100%', border: 'none',position:'absolute',zIndex:10}}>
          <div id="text-overlay" contentEditable style={{overflow: 'auto', padding:30, width:300, backgroundColor: '#333333', color:'white', textAlign: 'left',fontSize:'1.2em', border: 'ridge 1px',marginBottom: 5}}>
            {displayBottomText}
          </div>
        </div>
        <div id="search-data" style={{zIndex:5, position:'absolute', top:80, right:5, visibility:'hidden'}}>
          <Accordion id="search-accordion" style={{width:380}}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-label="Expand"
              aria-controls="additional-actions1-content"
              id="additional-actions1-header"
              style={{height:35, paddingTop:5}}
            >
            <CancelIcon id="search-cancel" style={{paddingRight:10, position:'relative', top:-3}}/>
            <span id="search-label">Sirius</span>
            </AccordionSummary>
            <AccordionDetails>
              <Typography style={{textAlign: 'left'}}>
              <span id="search-text">A class star, apparent brightness
                largest in sky.</span>
                </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    );
  }
}

export default AppContent;
